import {
  ATHLETE_LEVELS,
  ATHLETE_ROLES,
  BASKET__ROLES,
  BASKET_LEVELS,
  GYM_LEVELS,
  GYM_ROLES,
  RUGBY_UNION_LEVELS,
  RUGBY_UNION_ROLES,
  SOCCER_LEVELS,
  SOCCER_ROLES,
  SPACE_GENDERS,
  SPACE_TYPES,
  VOLLEYBALL_LEVELS,
  VOLLEYBALL_ROLES,
} from "../enums/Space";
import { RoutesReact } from "./routes";
import { USER_TYPES } from "../enums/user";
import { USER_STATES } from "../models/User";
import { EVENT_TEST_TYPES, EVENT_TYPES } from "../enums/event";
import {
  EVENT_RESULT_CALC_TYPES,
  EVENT_RESULT_SKIP_MOTIVATION,
  EVENT_RESULT_UNITS,
} from "../enums/eventresults";

export const BASE_URL_EXERCISE = `https://local-test-leopart-coach-image.s3.eu-central-1.amazonaws.com/`;
export const BASE_URL_IMAGE = `https://local-test-leopart-coach-image.s3.eu-central-1.amazonaws.com/`;

export const UNITS_EXERCISE = [
  {
    label: "Peso",
    unit: "kg",
    value: "weight",
  },
  { label: "Newton", value: "newton", unit: "N" },
  {
    label: "Velocity",
    value: "velocity",
    unit: "m/s",
  },
];

export const ENDPOINT_WITHOUT_BEARER = [
  RoutesReact.ATHLETE_LOGIN,
  "/auth/login",
  "/auth/refresh",
  "/director/login",
  "/director/confirm-register",
  "/users/verify-token",
  "/users/confirm-token",
  "/director/check-confirm-token",
];

export const TYPE_TEAM_OPTIONS = [
  {
    label: "Calcio",
    value: SPACE_TYPES.SOCCER,
  },
  {
    label: "Atletica",
    value: SPACE_TYPES.ATHLETICS,
  },
  {
    label: "Basket",
    value: SPACE_TYPES.BASKET,
  },
  {
    label: "Rugby a 15",
    value: SPACE_TYPES.RUGBY_UNION,
  },
  {
    label: "Pallavolo",
    value: SPACE_TYPES.VOLLER_BALL,
  },
  {
    label: "Palestra",
    value: SPACE_TYPES.GYM,
  },
];
export const GENDER_TEAM_OPTIONS = [
  {
    label: "Maschile",
    value: SPACE_GENDERS.MALE,
  },
  {
    label: "Femminile",
    value: SPACE_GENDERS.FEMALE,
  },
  {
    label: "Misto",
    value: SPACE_GENDERS.MIXED,
  },
];

export const USER_TYPE_OPTIONS = [
  {
    label: "Atleta",
    value: USER_TYPES.ATHLETE,
  },
  {
    label: "Coach",
    value: USER_TYPES.COACH,
  },
  {
    label: "Amministratore",
    value: USER_TYPES.ADMINISTRATOR,
  },
];

export const USER_STATE_OPTIONS = [
  {
    label: "Inattivo",
    value: USER_STATES.INACTIVE,
  },

  {
    label: "Attivo",
    value: USER_STATES.ACTIVE,
  },
];

export const DEFAULT_LIMIT_TABLES = [1, 2, 5, 10, 20, 50, 100];

export const LEVELS_SPORT_OPTIONS = {
  [SPACE_TYPES.ATHLETICS]: [
    { value: ATHLETE_LEVELS.BEGINNERS, label: "Esordienti" },
    { value: ATHLETE_LEVELS.BOYS, label: "Ragazzi" },
    { value: ATHLETE_LEVELS.CADETS, label: "Cadetti" },
    { value: ATHLETE_LEVELS.JUNIORS, label: "Allievi" },
    { value: ATHLETE_LEVELS.JUNIORES, label: "Juniores" },
    { value: ATHLETE_LEVELS.PROMISES, label: "Promesse" },
    { value: ATHLETE_LEVELS.SENIORS_ABSOLUTE, label: "Seniores / Assoluti" },
  ],
  [SPACE_TYPES.SOCCER]: [
    { value: SOCCER_LEVELS.UNDER_6, label: "Under 6" },
    { value: SOCCER_LEVELS.UNDER_7, label: "Under 7" },
    { value: SOCCER_LEVELS.UNDER_8, label: "Under 8" },
    { value: SOCCER_LEVELS.UNDER_9, label: "Under 9" },
    { value: SOCCER_LEVELS.UNDER_10, label: "Under 10" },
    { value: SOCCER_LEVELS.UNDER_11, label: "Under 11" },
    { value: SOCCER_LEVELS.UNDER_12, label: "Under 12" },
    { value: SOCCER_LEVELS.UNDER_13, label: "Under 13" },
    { value: SOCCER_LEVELS.UNDER_14, label: "Under 14" },
    { value: SOCCER_LEVELS.UNDER_15, label: "Under 15" },
    { value: SOCCER_LEVELS.UNDER_16, label: "Under 16" },
    { value: SOCCER_LEVELS.UNDER_17, label: "Under 17" },
    { value: SOCCER_LEVELS.UNDER_18, label: "Under 18" },
    { value: SOCCER_LEVELS.UNDER_19, label: "Under 19" },
    { value: SOCCER_LEVELS.UNDER_20, label: "Under 20" },
    { value: SOCCER_LEVELS.UNDER_21, label: "Under 21" },
    { value: SOCCER_LEVELS.UNDER_23, label: "Under 23" },
    { value: SOCCER_LEVELS.FIRST_TEAM, label: "Prima Squadra" },
  ],
  [SPACE_TYPES.BASKET]: [
    {
      value: BASKET_LEVELS.SQUIRRELS_DRAGONFLIES,
      label: "Scoiattoli",
    },
    { value: BASKET_LEVELS.EAGLETS_GAZELLES, label: "Aquilotti" },
    { value: BASKET_LEVELS.BEGINNERS, label: "Esordienti" },
    { value: BASKET_LEVELS.UNDER_13, label: "Under 13" },
    { value: BASKET_LEVELS.UNDER_14, label: "Under 14" },
    { value: BASKET_LEVELS.UNDER_15, label: "Under 15" },
    { value: BASKET_LEVELS.UNDER_16, label: "Under 16" },
    { value: BASKET_LEVELS.UNDER_17_18, label: "Under 17/18" },
    { value: BASKET_LEVELS.UNDER_19_20, label: "Under 19/20" },
    { value: BASKET_LEVELS.FIRST_TEAM, label: "Prima Squadra" },
  ],
  [SPACE_TYPES.RUGBY_UNION]: [
    { value: RUGBY_UNION_LEVELS.UNDER_5_7_9, label: "Under 5/7/9" },
    { value: RUGBY_UNION_LEVELS.UNDER_11, label: "Under 11" },
    { value: RUGBY_UNION_LEVELS.UNDER_13, label: "Under 13" },
    { value: RUGBY_UNION_LEVELS.UNDER_15, label: "Under 15" },
    { value: RUGBY_UNION_LEVELS.UNDER_17, label: "Under 17" },
    { value: RUGBY_UNION_LEVELS.UNDER_19, label: "Under 19" },
    { value: RUGBY_UNION_LEVELS.FIRST_TEAM, label: "Prima Squadra" },
  ],
  [SPACE_TYPES.VOLLER_BALL]: [
    { value: VOLLEYBALL_LEVELS.S3_WHITE, label: "S3 Bianco" },
    { value: VOLLEYBALL_LEVELS.S3_GREEN, label: "S3 Verde" },
    { value: VOLLEYBALL_LEVELS.S3_RED, label: "S3 Rosso" },
    { value: VOLLEYBALL_LEVELS.UNDER_12, label: "Under 12" },
    { value: VOLLEYBALL_LEVELS.UNDER_13_14, label: "Under 13/14" },
    { value: VOLLEYBALL_LEVELS.UNDER_15_16, label: "Under 15/16" },
    { value: VOLLEYBALL_LEVELS.UNDER_17_18, label: "Under 17/18" },
    { value: VOLLEYBALL_LEVELS.UNDER_19_20, label: "Under 19/20" },
    { value: VOLLEYBALL_LEVELS.FIRST_TEAM, label: "Prima Squadra" },
  ],
  [SPACE_TYPES.GYM]: [
    { value: GYM_LEVELS.BEGINNER, label: "Principiante" },
    { value: GYM_LEVELS.INTERMEDIATE, label: "Intermedio" },
    { value: GYM_LEVELS.ADVANCED, label: "Avanzato" },
    { value: GYM_LEVELS.COMPETITIVE, label: "Agonistico" },
  ],
};

export const ROLES_SPORT_OPTIONS = {
  [SPACE_TYPES.SOCCER]: [
    { value: SOCCER_ROLES.GOALKEEPER, label: "Portiere" },
    { value: SOCCER_ROLES.DEFENDER, label: "Difensore" },
    { value: SOCCER_ROLES.MIDFIELDER, label: "Centrocampista" },
    { value: SOCCER_ROLES.WINGER, label: "Esterno" },
    { value: SOCCER_ROLES.FORWARD, label: "Attaccante" },
  ],

  [SPACE_TYPES.BASKET]: [
    { value: BASKET__ROLES.POINT_GUARD, label: "Playmaker" },
    { value: BASKET__ROLES.SHOOTING_GUARD, label: "Guardia tiratrice" },
    { value: BASKET__ROLES.SMALL_FORWARD, label: "Ala piccola" },
    { value: BASKET__ROLES.POWER_FORWARD, label: "Ala grande" },
    { value: BASKET__ROLES.CENTER, label: "Centro" },
  ],

  [SPACE_TYPES.RUGBY_UNION]: [
    { value: RUGBY_UNION_ROLES.PROP, label: "Pilone" },
    { value: RUGBY_UNION_ROLES.HOOKER, label: "Tallonatore" },
    { value: RUGBY_UNION_ROLES.LOCK, label: "Seconda linea" },
    { value: RUGBY_UNION_ROLES.FLANKER, label: "Terza linea ala" },
    { value: RUGBY_UNION_ROLES.NUMBER_8, label: "Terza linea centro (n°8)" },
    { value: RUGBY_UNION_ROLES.SCRUM_HALF, label: "Mediano di mischia" },
    { value: RUGBY_UNION_ROLES.CENTER, label: "Centro" },
    { value: RUGBY_UNION_ROLES.RIGHT_WING, label: "Ala destra" },
    { value: RUGBY_UNION_ROLES.FULLBACK, label: "Estremo" },
  ],

  [SPACE_TYPES.VOLLER_BALL]: [
    { value: VOLLEYBALL_ROLES.SETTER, label: "Palleggiatore" },
    { value: VOLLEYBALL_ROLES.OPPOSITE_HITTER, label: "Opposto" },
    { value: VOLLEYBALL_ROLES.OUTSIDE_HITTER, label: "Schiacciatore / Banda" },
    { value: VOLLEYBALL_ROLES.MIDDLE_BLOCKER, label: "Centrale" },
    { value: VOLLEYBALL_ROLES.LIBERO, label: "Libero" },
  ],

  [SPACE_TYPES.GYM]: [
    { value: GYM_ROLES.POWERLIFTER, label: "Powerlifter" },
    { value: GYM_ROLES.BODYBUILDER, label: "Bodybuilder" },
    { value: GYM_ROLES.CROSSFIT_ATHLETE, label: "Atleta CrossFit" },
    { value: GYM_ROLES.FUNCTIONAL_ATHLETE, label: "Atleta Functional" },
    { value: GYM_ROLES.CARDIO_ATHLETE, label: "Atleta Cardio" },
    { value: GYM_ROLES.GENERAL, label: "Generico" },
  ],

  [SPACE_TYPES.ATHLETICS]: [
    { value: ATHLETE_ROLES.SPRINTER_100, label: "Velocista 100 m" },
    { value: ATHLETE_ROLES.SPRINTER_200, label: "Velocista 200 m" },
    { value: ATHLETE_ROLES.SPRINTER_400, label: "Velocista 400 m" },
    { value: ATHLETE_ROLES.MIDDLE_DISTANCE_800, label: "Mezzofondista 800 m" },
    {
      value: ATHLETE_ROLES.MIDDLE_DISTANCE_1500,
      label: "Mezzofondista 1500 m",
    },
    {
      value: ATHLETE_ROLES.MIDDLE_DISTANCE_3000,
      label: "Mezzofondista 3000 m",
    },
    { value: ATHLETE_ROLES.HURDLER_100, label: "Ostacolista 100 m (donne)" },
    { value: ATHLETE_ROLES.HURDLER_110, label: "Ostacolista 110 m (uomini)" },
    { value: ATHLETE_ROLES.HURDLER_400, label: "Ostacolista 400 m" },
    { value: ATHLETE_ROLES.LONG_DISTANCE_5000, label: "Fondo 5000 m" },
    { value: ATHLETE_ROLES.LONG_DISTANCE_10000, label: "Fondo 10000 m" },
    { value: ATHLETE_ROLES.MARATHON, label: "Maratoneta" },
    { value: ATHLETE_ROLES.RELAY_4X100, label: "Staffetta 4x100 m" },
    { value: ATHLETE_ROLES.RELAY_4X400, label: "Staffetta 4x400 m" },
    { value: ATHLETE_ROLES.HIGH_JUMPER, label: "Saltatore in alto" },
    { value: ATHLETE_ROLES.LONG_JUMPER, label: "Saltatore in lungo" },
    { value: ATHLETE_ROLES.TRIPLE_JUMPER, label: "Triplista" },
    { value: ATHLETE_ROLES.POLE_VAULTER, label: "Saltatore con l’asta" },
    { value: ATHLETE_ROLES.SHOT_PUTTER, label: "Getto del peso" },
    { value: ATHLETE_ROLES.DISCUS_THROWER, label: "Lanciatore del disco" },
    {
      value: ATHLETE_ROLES.JAVELIN_THROWER,
      label: "Lanciatore del giavellotto",
    },
    { value: ATHLETE_ROLES.HAMMER_THROWER, label: "Lanciatore del martello" },
  ],
};

export const EVENT_TYPES_OPTIONS = [
  {
    label: "Allenamento",
    value: EVENT_TYPES.WORKOUT,
  },
  {
    label: "Test",
    value: EVENT_TYPES.TEST,
  },
  {
    label: "Test",
    value: EVENT_TYPES.SYSTEM_TEST_EVENT,
  },
  {
    label: "Gara/Match",
    value: EVENT_TYPES.MATCH,
  },
];

export const EVENT_RESULT_SKIP_OPTIONS = [
  {
    label: "Infortunio",
    value: EVENT_RESULT_SKIP_MOTIVATION.INJURY,
  },
  {
    label: "Problemi personali",
    value: EVENT_RESULT_SKIP_MOTIVATION.PERSONAL_PROBLEMS,
  },
  {
    label: "Altro",
    value: EVENT_RESULT_SKIP_MOTIVATION.OTHER,
  },
];

export const EVENT_TEST_TYPES_OPTIONS = [
  {
    label: "Drop Jump",
    value: EVENT_TEST_TYPES.DROP_JUMP,
  },
  {
    label: "Cmj",
    value: EVENT_TEST_TYPES.CMJ,
  },
];

export const EVENT_RESULT_TYPES_OPTIONS = [
  {
    label: "Centimetri",
    value: EVENT_RESULT_UNITS.CM,
  },
  {
    label: "Inches",
    value: EVENT_RESULT_UNITS.IN,
  },
];

export const EVENT_RESULT_CALC_TYPES_OPTIONS = [
  {
    label: "Media",
    value: EVENT_RESULT_CALC_TYPES.AVERAGE,
  },
  {
    label: "Picco",
    value: EVENT_RESULT_CALC_TYPES.PEAK,
  },
];


